// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"799c0557","239":"80bccc9f","453":"516493f6","455":"b9ad0bc2","885":"4994593f"}[chunkId] + ".chunk.js";
};